const NotFoundPage = (): React.ReactElement => {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>The requested page does not exist.</p>
    </div>
  );
};

export default NotFoundPage;
